import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import { IdeaTopCardFragment } from '../../../../__generated__/IdeaTopCardFragment';
import { FixedFees } from './FixedFees';
import { TariffView } from './Tariff';

import './index.scss';

interface Props {
  idea: IdeaTopCardFragment;
}

const b = b_.with('idea-top-card-fees');

export const Fees: React.FC<Props> = ({ idea }) => {
  const { t } = useTranslation();
  return (
    <div className={b()}>
      <div className={b('title')}>{t('Fees')}</div>
      <div>
        {idea.tariffGrid ? <TariffView tariffGrid={idea.tariffGrid} /> : <FixedFees idea={idea} />}
      </div>
    </div>
  );
};
